import { getRandomValues } from 'node:crypto';

/**
 * Create a random salt (nonce) for cryptographic operations.
 *
 * @param length - Length of the salt in bytes
 * @returns Random salt buffer
 */
export function createSalt(length: number): Buffer {
    return getRandomValues(Buffer.alloc(length));
}

